import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useReducedMotion } from '../hooks/useReducedMotion';

const FinalCTA = () => {
  const prefersReduced = useReducedMotion();

  return (
    <section className="relative py-24 bg-jungle-900 overflow-hidden">
      {/* Film grain */}
      <div className="film-grain absolute inset-0 pointer-events-none" />

      {/* Tropical foliage top edge */}
      <svg
        className="absolute top-0 left-0 right-0 w-full h-12 text-cream"
        viewBox="0 0 1440 48"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <path d="M0,0 C240,48 480,0 720,24 C960,48 1200,0 1440,24 L1440,0 L0,0 Z" />
      </svg>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={prefersReduced ? {} : { opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl sm:text-5xl md:text-6xl font-display text-cream leading-tight mb-6"
        >
          Ready To Bring A{' '}
          <span className="text-amber text-shadow-glow">RoARsOME</span>{' '}
          Adventure To Your Event?
        </motion.h2>

        <motion.p
          initial={prefersReduced ? {} : { opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-lg text-cream/70 mb-10 max-w-2xl mx-auto"
        >
          Tell us your event date and expected crowd size — we'll send your custom quote within 24 hours.
        </motion.p>

        <motion.div
          initial={prefersReduced ? {} : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: 'spring', stiffness: 200, damping: 20, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link to="/contact" className="btn-primary text-lg px-10 py-4 animate-pulse-amber">
            Get Your Custom Quote
          </Link>
          <Link to="/packages" className="btn-secondary text-lg px-10 py-4">
            View Packages & Pricing
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
